import React from "react";
import styled from "styled-components";

import BaseModal from "./BaseModal";
import { ModalContent } from "./modal.styles";
import { ButtonOk } from "../../styles/button";

const FlexCenter = styled.div`
  height: 100%;
  display: flex;
  justify-content: space-evenly;
  align-items: flex-start;
  flex-direction: column;
  padding: 32px;
`;

const H1 = styled.h1`
  font-size: 24px;
  font-weight: bold;
  letter-spacing: 0.5px;
`;

const P = styled.p`
  text-align: left;
`;

class MessageModal extends React.Component {
  render() {
    return (
      <BaseModal
        height={"30vh"}
        width={"60%"}
        onHideClick={this.props.onHideClick}
      >
        <ModalContent>
          <FlexCenter>
            <H1>{this.props.title}</H1>
            <P>{this.props.message}</P>
            <ButtonOk onClick={this.props.onHideClick}>Got It</ButtonOk>
          </FlexCenter>
        </ModalContent>
      </BaseModal>
    );
  }
}

export default MessageModal;



// WEBPACK FOOTER //
// ./src/components/Modals/MessageModal.js